module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-vod-7-years.69dabbb2.svg";